import Resource from '@/api/resources/Resource'

class ConfigurationDepartmentServices extends Resource {
    async paginator(filterModel, params) {
        const response = await this.axios.put(`/configuration/departments`, filterModel, { params })
        return response.data
    }
    async getDepartmentsByName(params) {
        const response = await this.axios.get(`/configuration/departments/search`, { params })
        return response.data
    }
    async patchDepartmentsBatch(departments) {
        const response = await this.axios.patch(`/configuration/departments/batch`, departments)
        return response.data
    }
    async createDepartment(department) {
        const response = await this.axios.post(`/configuration/departments`, department)
        return response.data
    }
    async deleteDepartmentsBatch(departmentsIds) {
        const data = {
            entityIdentifiers: departmentsIds
        }
        const response = await this.axios.delete(`/configuration/departments/batch`, { data: data })
        return response.data
    }
}

export default new ConfigurationDepartmentServices()
